import React from 'react';
import CountryLabel from '../../../../components/CountryLabel';
import moment from 'moment';
import styled from 'styled-components';
import { I18n } from 'react-redux-i18n';

const SurveyContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-family: ${(props) => props.theme.fonts.sfcompact_text};
  line-height: 24px;

  .surveyValue {
    min-width: 46px;
    height: 46px;
    background-color: rgba(43, 61, 84, 0.05);
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px !important;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-weight: 600;
    border-radius: 8px;
    color: #2b3d54;
  }

  .surveyContent {
    margin-left: 15px;
  }

  .surveyText {
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 16px;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    color: #2b3d54;
  }

  .surveyDate {
    color: #2b3d54;
    opacity: 0.5;
    white-space: nowrap;
  }
`;

const Survey = (campaign) => (
  <SurveyContainer>
    <div className="surveyValue">{campaign.dn}</div>
    <div className="surveyContent">
      <div className="surveyText">
        <p>{`${
          campaign.network &&
          (campaign.network.code === 'ON'
            ? I18n.t('restaurants&caves.kpiTextRestaurant')
            : I18n.t('restaurants&caves.kpiTextCave'))
        } ${I18n.t('at')} ${campaign.market && campaign.market.name}`}</p>
        {campaign.country && (
          <CountryLabel
            name={campaign.country.code}
            style={{ marginLeft: 5 }}
            styleLabel={{
              fontSize: 16,
              color: '#2B3D54',
              opacity: 0.5,
              letterSpacing: -0.32,
              lineHeight: '20px'
            }}
          />
        )}
      </div>
      <div className="surveyDate">
        {I18n.t('restaurants&caves.feedText')}{' '}
        {moment(new Date(campaign.year, campaign.month - 1, 1)).format(
          'MMMM - YYYY'
        )}
      </div>
    </div>
  </SurveyContainer>
);

export default Survey;
